<script>
  //// imports
  import { useNavigate } from "svelte-navigator";
  import { ROUTES } from "@utils/routes.js";
  import { filtersConfigStore } from "@stores/filtersConfigStores.js";
  import { getApplicableFilters } from "../../../../lib/util/getDamApplicableFilters";
  import { pmfilters } from "lib/stores.js";

  import Filter from "./components/filter/Filter.svelte";
  import FilterToast from "./components/FilterToast.svelte";

  import Button from "lib/components/Button.svelte";
  import Header from "lib/components/Header.svelte";
  import DashboardSectionHeading from "./components/dashboardSectionHeading.svelte";
  import DashboardTileShare from "./components/dashboardTileShare.svelte";
  import DashboardTileTop5 from "./components/dashboardTileTop5.svelte";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";

  export let analysisid;
  const navigate = useNavigate();

  const { setCurrentView } = filtersConfigStore;

  let loadingFinalLog = true;
  let loadingAppLog = true;
  let loadingUILog = true;
  let showToast = false;
  let view = "Dashboard";

  //// data

  let finalLog = {
    topactivities: [],
    topprocesses: [],
    topprocesslength: [],
    topprocessvariants: [],
    totalactivities: 0,
    totalevents: 0,
    totalprocesses: 0,
    totalteams: 0,
  };

  let appLog = {
    sharemappedactivities: 0,
    sharemappedtypes: 0,
    sharesystemstime: [],
    topapps: [],
    topmasksin: [],
    topmasksout: [],
    topwindows: [],
    totalapps: 0,
    totalinterfaces: 0,
    totalmasks: 0,
  };

  let uiLog = {
    sharesystemsactions: [],
    sharesystemsshortcuts: [],
    topappsinteraction: [],
    topcopypaste: [],
    topshortcuts: [],
    topwindowsinteraction: [],
  };

  $: setCurrentView(view);

  $: {
    if ($pmfilters && $filtersConfigStore.storeLoaded) {
      const applicableFilters = getApplicableFilters($pmfilters[analysisid]);
      getAppLog(applicableFilters);
      getFinalLog(applicableFilters);
      getUILog(applicableFilters);
    }
  }

  function getAppLog(applicableFilters) {
    loadingAppLog = true;
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/analysis/Dashboard_appLog?analysisid=${analysisid}&filter=${filterString}`,
    )
      .then((response) => response.json())
      .then((data) => {
        appLog = data;
        loadingAppLog = false;
      })
      .catch((err) => {
        console.log(err);
        loadingAppLog = false;
      });
  }

  function getFinalLog(applicableFilters) {
    loadingFinalLog = true;
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/analysis/Dashboard_finalLog?analysisid=${analysisid}&filter=${filterString}`,
    )
      .then((response) => response.json())
      .then((data) => {
        finalLog = data;
        loadingFinalLog = false;
      })
      .catch((err) => {
        console.log(err);
        loadingFinalLog = false;
      });
  }

  function getUILog(applicableFilters) {
    loadingUILog = true;
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/analysis/Dashboard_UILog?analysisid=${analysisid}&filter=${filterString}`,
    )
      .then((response) => response.json())
      .then((data) => {
        uiLog = data;
        loadingUILog = false;
      })
      .catch((err) => {
        console.log(err);
        loadingUILog = false;
      });
  }
</script>

<FilterToast bind:showToast></FilterToast>

<Header section={view} area={view} breadcrumb="Overview" paddingRight={false}>
  <!-- <Select placeholder="Country" />
  <Select placeholder="Area" />
  <Select placeholder="Project" />
  <Select placeholder="Team" />
  <Button text="Back" variant="secondary" iconLeft={true} icon="arrow_left" /> -->
  <Filter />
</Header>

<div class="content_wrapper">
  <div class="main_content">
    <!-- Start of Usage - Analysis -->
    <div class="main_content_section usage_ana">
      <DashboardSectionHeading
        heading="Usage Analysis"
        name="Mapped:"
        value={appLog.sharemappedtypes}
        unit="%"
      />
      <div class="tiles">
        <DashboardTileShare
          loading={loadingAppLog}
          category="Time Share"
          shareCat01={appLog.sharesystemstime.find(
            (action) => action.name === "main",
          )?.value || 0}
          shareCat02={appLog.sharesystemstime.find(
            (action) => action.name === "supportive",
          )?.value || 0}
          shareCat03={appLog.sharesystemstime.find(
            (action) => action.name === "unwanted",
          )?.value || 0}
        >
          <Button
            iconRight={false}
            text="Treemap"
            variant="secondary"
            on:click={() =>
              navigate(ROUTES.analysis.treemap + `?analysisid=${analysisid}`)}
          />
          <Button
            iconRight={false}
            text="App Users"
            variant="secondary"
            on:click={() =>
              navigate(ROUTES.analysis.workload + `?analysisid=${analysisid}`)}
          />
        </DashboardTileShare>
        <DashboardTileTop5
          loading={loadingAppLog}
          heading="Apps"
          data01={appLog["topapps"]}
          data02={uiLog["topappsinteraction"]}
          selection01="Time"
          selection02="Actions"
          isTime={[true, false]}
        />
        <DashboardTileShare
          loading={loadingUILog}
          category="Action Share"
          shareCat01={uiLog.sharesystemsactions.find(
            (action) => action.name === "main",
          )?.value || 0}
          shareCat02={uiLog.sharesystemsactions.find(
            (action) => action.name === "supportive",
          )?.value || 0}
          shareCat03={uiLog.sharesystemsactions.find(
            (action) => action.name === "unwanted",
          )?.value || 0}
        >
          <Button
            iconRight={false}
            text="Mask Analysis"
            variant="secondary"
            on:click={() =>
              navigate(ROUTES.analysis.heatmap + `?analysisid=${analysisid}`)}
          />
        </DashboardTileShare>
        <DashboardTileTop5
          loading={loadingAppLog}
          heading="Masks"
          data01={appLog["topwindows"]}
          data02={uiLog["topwindowsinteractions"]}
          selection01="Time"
          selection02="Actions"
          isTime={[true, false]}
        />
        <DashboardTileShare
          loading={loadingUILog}
          category="Shortcut Share"
          shareCat01={uiLog.sharesystemsshortcuts.find(
            (action) => action.name === "main",
          )?.value || 0}
          shareCat02={uiLog.sharesystemsshortcuts.find(
            (action) => action.name === "supportive",
          )?.value || 0}
          shareCat03={uiLog.sharesystemsshortcuts.find(
            (action) => action.name === "unwanted",
          )?.value || 0}
        >
          <Button
            iconRight={false}
            text="General"
            variant="secondary"
            on:click={() =>
              navigate(ROUTES.analysis.shortcuts + `?analysisid=${analysisid}`)}
          />
          <!-- <Button
            iconRight={false}
            text="Copy & Paste"
            variant="secondary"
            on:click={() => navigate(ROUTES.analysis.copypaste + `?analysisid=${analysisid}`)}
          /> -->
        </DashboardTileShare>
        <DashboardTileTop5
          loading={loadingUILog}
          heading="Shortcuts"
          data01={uiLog["topshortcuts"]}
          data02={uiLog["topcopypaste"]}
          selection01="General"
          selection02="Copy & Paste"
        />
      </div>
    </div>
    <!-- Start of Workflow - Analysis -->
    <div class="main_content_section usage_ana">
      <DashboardSectionHeading
        heading="Workflow Analysis"
        name="Mapped:"
        value={appLog.sharemappedactivities}
        unit="%"
      />
      <div class="tiles">
        <DashboardTileShare
          loading={loadingFinalLog}
          category="Process Info"
          cat01="Workflows"
          shareCat01={finalLog.totalprocesses}
          cat02="Activities"
          shareCat02={finalLog.totalactivities}
          cat03="Events"
          shareCat03={finalLog.totalevents}
          share={false}
        >
          <Button
            iconRight={false}
            text="Workflows"
            variant="secondary"
            on:click={() =>
              navigate(ROUTES.analysis.workflow + `?analysisid=${analysisid}`)}
          />
          <!-- <Button iconRight={true} text="Cases" variant="secondary" /> -->
        </DashboardTileShare>
        <DashboardTileTop5
          loading={loadingFinalLog}
          heading="Processes"
          data01={finalLog["topprocesses"]}
          data02={finalLog["topactivities"]}
          selection01="Processes"
          selection02="Activities"
        />
        <DashboardTileShare
          loading={loadingAppLog}
          category="Interface Info"
          cat01="Apps"
          shareCat01={appLog.totalapps}
          cat02="Masks"
          shareCat02={appLog.totalmasks}
          cat03="Interfaces"
          shareCat03={appLog.totalinterfaces}
          share={false}
        >
          <Button
            iconRight={false}
            text="Interfaces"
            variant="secondary"
            on:click={() =>
              navigate(
                ROUTES.analysis.connections + `?analysisid=${analysisid}`,
              )}
          />
        </DashboardTileShare>
        <DashboardTileTop5
          loading={loadingAppLog}
          heading="Interfaces"
          selection01="In"
          data01={appLog["topmasksin"]}
          selection02="Out"
          data02={appLog["topmasksout"]}
        />
        <DashboardTileShare
          loading={loadingFinalLog}
          category="Models Info"
          shareCat01={finalLog.totalprocesses}
          shareCat02="1"
          shareCat03="9"
          share={false}
          cat01="Workflows"
          cat02="Teams"
          cat03="Diagrams"
        >
          <Button
            iconRight={false}
            text="BPMN"
            variant="secondary"
            on:click={() =>
              navigate(
                ROUTES.analysis.bpmnexport + `?analysisid=${analysisid}`,
              )}
          />
          <!-- <Button iconRight={true} text="Procceses" variant="secondary" /> -->
        </DashboardTileShare>
        <DashboardTileTop5
          loading={loadingFinalLog}
          heading="Models"
          data01={finalLog["topprocesslength"]}
          data02={finalLog["topprocessvariants"]}
          selection01="Lenght"
          selection02="Variants"
        />
      </div>
    </div>

    <div class="paxbot_wrapper">
      <DashboardSectionHeading
        buttonDisabled={true}
        buttonText="Paxbot"
        heading="Paxbot"
        paxbot={true}
      />
      <div class="paxbot">
        <div class="paxbot_top">
          <div class="paxbot_text">
            <div class="paxbot_heading">
              <div class="bold">Next Best Actions (AI)</div>
              <img
                class="pax_icon"
                src="/icons/paxray_icon.svg"
                alt="paxray_icon"
              />
            </div>
            <div class="paxbot_intro">
              <span class="bold">Coming soon!</span> Empower Your Decisions with
              AI-Driven Improvement Ideas from Paxbot.
            </div>
          </div>
        </div>
        <div class="paxbot_bottom">
          <div class="button_container">
            <Button
              setting={true}
              variant="secondary"
              disabled={true}
              text="Start Paxbot"
            />
          </div>
          <img
            class="paxbot_portrait"
            src="/img/assistant/paxbot_portrait.png"
            alt="paxbot"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .main_content {
    display: grid;
    grid-template-columns: 2fr 2fr 1fr;
    gap: 1rem;
  }

  .main_content_section {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .tiles {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }

  .content_wrapper {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    gap: 1rem;
  }

  .paxbot_wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: 100%;
  }

  .paxbot {
    flex-grow: 1;
    background: linear-gradient(to bottom, #ff5f1f, #ffffff);
    color: white;
    padding: 1rem;
    padding-bottom: 0;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .paxbot_heading {
    padding-bottom: 1rem;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid white;
  }

  .pax_icon {
    height: 0.8rem;
  }

  .paxbot_intro {
    margin-top: 0.6rem;
    line-height: 1.4rem;
  }

  .paxbot_bottom {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .paxbot_portrait {
    width: 40%;
  }

  .button_container {
    margin-bottom: 1rem;
  }
</style>
